module.exports = __webpack_public_path__ + "static/media/bg_img.874733f3.jpg";